// axios-config.js

import axios from 'axios';

// Set up Axios interceptors
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      console.error('Response Error:', error.response.status, error.response.data);
      // Handle error response and show a user-friendly message
    } else if (error.request) {
      console.error('Request Error:', error.request);
      // Handle request error and show a user-friendly message
      // alert('Bad Internet Connection');
    } else {
      console.error('Error:', error.message);
      // Handle other errors and show a user-friendly message
      // alert('Bad Internet Connection');
    }
    return Promise.reject(error);
  }
);

export default axios;
